import WidgetOrganization from './WidgetOrganization';

export default WidgetOrganization;
